import { library } from "@fortawesome/fontawesome-svg-core";

// Brand icons only (social media) - free-brands-svg-icons
import {
  faGithub,
  faTwitter,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";

library.add(faGithub, faTwitter, faInstagram);
